import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthenticationApiService } from '@warema/shared/authentication/api';
import { IAppConfig, WaremaPlusEnvironment, ENVIRONMENT } from '@warema/shared/models';
import { AppointmentTrackingService } from '@warema/shared/services';
import { SharedSvgModule } from '@warema/shared/svg';
import { TenantConfigurationService } from '@warema/shared/tenant-config';

@Component({
    selector: 'warema-dashboard-private',
    templateUrl: './dashboard-private.component.html',
    styleUrls: ['./dashboard-private.component.scss'],
    imports: [TranslatePipe, MatButtonModule, RouterModule, SharedSvgModule, AsyncPipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardPrivateComponent {
    public readonly authenticationApiService = inject(AuthenticationApiService);
    private readonly _trackingService = inject(AppointmentTrackingService);
    private readonly _tenantConfig = inject(TenantConfigurationService);
    private readonly _environment = inject<WaremaPlusEnvironment>(ENVIRONMENT);

    public settings: IAppConfig | null;

    private readonly _dealerBannerBackgroundUri = '/images/dashboard/private_dashboard_dealer_banner_background.png';
    private readonly _appointmentBannerBackgroundUri =
        '/images/dashboard/private_dashboard_appointment_banner_background.png';
    private readonly _productRegistrationBannerBackgroundUri =
        '/images/dashboard/private_dashboard_product_registration_banner_background.jpg';
    public readonly dealerBannerImgSrc = `${this._environment.baseLeadCloudUrl}${this._dealerBannerBackgroundUri}`;
    public readonly appointmentBannerImgScr = `${this._environment.baseLeadCloudUrl}${this._appointmentBannerBackgroundUri}`;
    public readonly productRegistrationBannerImgScr = `${this._environment.baseLeadCloudUrl}${this._productRegistrationBannerBackgroundUri}`;
    public readonly shopBannerImgScr = 'shared-assets/images/shop/fabrics.jpg';
    public readonly appointmentsBannerImgScr = 'assets/images/my-appointments-banner.png';
    public readonly configuratorBannerImgScr = 'assets/images/configurator-banner.jpg';

    constructor() {
        this.settings = this._tenantConfig.settings;
    }

    public openWaremaConfigurator(): void {
        window.open(`${this._environment.configuratorUrl}`, '_blank')?.focus();
    }

    public trackDealerBannerButton(): void {
        this._trackingService.trackDealerBannerButton();
    }

    public trackAppointmentBannerButton(): void {
        this._trackingService.trackAppointmentBannerButton();
    }
}
